import * as React from "react";
import { useState } from "react";
import { PatientChatListPanel } from "./PatientChatListPanel";
import { PatientChatsWrapper } from "./PatientChats.styles";
import { PatientChatListSearchView } from "./PatientChatListSearchView";
import { ChatListSearchAndFilter } from "../../ChatListSearchAndFilter";
import { GROUP_TYPE } from "@home-health-notify/domain";
import { FilteredPatientChatsContext } from "hhn-commons";

export enum CHAT_DETAILS {
  MORE = 0,
  LESS = 1,
  COMPACT = 2, // Avatar with name and services only — used in hidden chats
}

type PatientChatsProps = {
  selectedChatId?: string;
  unreadChatCount: number;
};

export const PatientChats = ({
  selectedChatId,
  unreadChatCount,
}: PatientChatsProps) => {
  const [chatItemView, setChatItemView] = useState(CHAT_DETAILS.MORE);
  const [searchMode, setSearchMode] = useState(false);

  const showSearchPanel = (): void => setSearchMode(true);

  const showChatListPanel = (): void => setSearchMode(false);

  const { fetchChats, resetChats } = React.useContext(
    FilteredPatientChatsContext,
  );

  return (
    <PatientChatsWrapper>
      <ChatListSearchAndFilter
        showSearchPanel={showSearchPanel}
        showChatListPanel={showChatListPanel}
        groupType={GROUP_TYPE.PATIENT}
        fetchChats={fetchChats}
        resetChats={resetChats}
      />
      {!searchMode ? (
        <PatientChatListPanel
          selectedChatId={selectedChatId}
          unreadChatCount={unreadChatCount}
          chatItemView={chatItemView}
          setChatItemView={setChatItemView}
        />
      ) : (
        <PatientChatListSearchView
          selectedChatId={selectedChatId}
          chatItemView={chatItemView}
          setChatItemView={setChatItemView}
        />
      )}
    </PatientChatsWrapper>
  );
};
